import { h, render } from 'preact';
import { chunk } from 'lodash-es';
import WishlistKing from './vendor/sdk';
import ProductVariants from '../components/products/ProductVariants';
import { gql } from '../shopify/api';
import { QUERY_PRODUCTS_BY_IDS } from '../shopify/queries';

let productItems = [];
let removeList = [];
let pageIndex = -1;

const deleteBtnEl = () => document.querySelector('.deleteWkItems');
const cancelDeleteBtnEl = () => document.querySelector('.cancelDelete');
const wishListBtnGroupEl = () => document.querySelector('.wkItemsBtnGroup');

export const initWishlistPage = (target) => {
  if (!document.querySelector('.wrapper.wk-page')) {
    target.append(WishlistKing.createComponent('wishlist-page'));
  }

  const renderPreactComponents = async (page) => {
    const container = document.getElementById('wishlist-results');
    if (!container) return;

    const productEls = Array.from(container.querySelectorAll('[data-render="product"]'));
    if (productEls.length === 0) return;

    const pages = chunk(productEls, 10);
    const shopifyIds = productEls.map((el) => `gid://shopify/Product/${el.dataset.shopifyId}`);

    if (page >= pages.length) return;

    const resp = await gql(QUERY_PRODUCTS_BY_IDS, { ids: shopifyIds });
    if (!resp.ok) throw new Error('Failed fetching products from Shopify GraphQL');

    const { data } = await resp.json();
    if (!data) throw new Error('Failed parsing json from Shopify GraphQL');

    let { nodes: products } = data;
    products = products.filter((p) => p);

    pages[page].forEach((el) => {
      const shopifyId = `gid://shopify/Product/${el.dataset.shopifyId}`;
      const product = products.find(({ id }) => id === shopifyId);

      if (product) {
        render(<ProductVariants product={product} />, el.querySelector('[data-component="ProductVariants"]'));
      }
    });

    if (Currency) {
      Currency.customConvertAll();
    }
  };

  function handleIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      pageIndex += 1;
      renderPreactComponents(pageIndex);

      observer.unobserve(entry.target);
    });
  }

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0,
  };

  setTimeout(() => {
    const intersectObserver = new IntersectionObserver(handleIntersect, options);

    productItems = document.querySelectorAll('.product__item');
    Array.from(productItems).forEach((val, index, arr) => index % 6 === 0 && intersectObserver.observe(arr[index]));
  }, 1000);
};

const cancelDelete = () => {
  removeList = [];
  productItems.forEach((pEl) => pEl.style.display === 'none' && (pEl.style.display = 'block'));
  wishListBtnGroupEl().classList.remove('tw-flex');
  wishListBtnGroupEl().classList.add('tw-hidden');
};

const postDeleteWishlistItems = async () => {
  try {
    await Promise.all(removeList.map((item) => WishlistKing.toolkit.removeItem(item)));
  } catch (e) {
    console.error(e);
  } finally {
    initWishlistPage(document.querySelector('#MainContent'));

    pageIndex = -1;
    removeList = [];
  }
};

export const deleteWishlistItem = ({ currentTarget }) => {
  removeList.push(currentTarget.getAttribute('data-wk-remove-item'));
  document.querySelector('.itemsCount').innerHTML = `${removeList.length}`;
  document.querySelector(`[data-wk-item='${currentTarget.dataset.wkRemoveItem}']`).style.display = 'none';

  wishListBtnGroupEl().classList.remove('tw-hidden');
  wishListBtnGroupEl().classList.add('tw-flex');

  cancelDeleteBtnEl().addEventListener('click', cancelDelete, { once: true });
  deleteBtnEl().addEventListener('click', postDeleteWishlistItems, { once: true });
};

export default {
  initWishlistPage,
  deleteWishlistItem,
};
